import Grid from '../components/grid';
import SolutionListItem from '../components/solution-list-item';
import Container from '../components/ui/container';
import React, { ReactElement } from 'react';

// TODO refactor this to remove 'solution' necessity

export default function FeaturedSolutionList(block: any): ReactElement {
  const { solutions } = block;
  return (
    <Container>
      <Grid className="lg:pb-[280px] xl:pb-[300px]">
        {/* {solutions &&
          solutions.map((solution: any, i: number) => (
            <SolutionListItem
              key={`featured-product-map--${solution.id}`}
              index={i}
              slug={solution.slug}
              image={block.}
              title={solution.title}
              description={solution.description}
            />
          ))} */}
      </Grid>
    </Container>
  );
}
